import { Injectable } from '@angular/core';
import { CustomStep } from 'marketpro-design-lib';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomStepsService {
  public currentCustomSteps = new BehaviorSubject<CustomStep[]>([]);
  private customSteps: number[] = [];
  constructor() {}

  public getCustomSteps(isCategoriesEnabled: boolean, customSteps?: number[]) {
    if (customSteps === this.customSteps) {
      return;
    }
    const labelGap = 2;
    let customLabels: { [key: number]: string } = {};
    if (customSteps?.length) {
      const minStep = Math.min(...customSteps);
      const maxStep = Math.max(...customSteps);
      // Create labels for the range between the min and max values of customSteps, ensuring no gaps between them.
      for (let i = minStep; i <= maxStep; i += labelGap) {
        customLabels[i] = String(i);
      }
      if (!customLabels[maxStep]) {
        customLabels[maxStep] = String(maxStep);
      }
      this.customSteps = customSteps;
    } else {
      customLabels = isCategoriesEnabled
        ? {
            2024: '2024',
            2026: '2026',
            2028: '2028',
            2030: '2030',
            2032: '2032',
            2034: '2034',
            2035: '2035',
          }
        : {
            2016: '2016',
            2018: '2018',
            2020: '2020',
            2022: '2022',
            2024: '2024',
            2026: '2026',
            2028: '2028',
            2030: '2030',
            2032: '2032',
            2034: '2034',
            2035: '2035',
          };
    }
    const keys = Object.keys(customLabels);
    const steps: CustomStep[] = [
      {
        from: Number(Object.keys(customLabels)[0]),
        to: Number(keys[keys.length - 1]),
        step: 1,
        labelGap: labelGap,
        customLabels: customLabels,
      },
    ];
    this.currentCustomSteps.next(steps);
  }
}
